<template>
  <div class="authorization-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <!-- 表格 -->
        <div class="filter-box">
          <div class="filter">
            <div class="filter-item">
              <p class="label">系统：</p>
              <el-select
                v-model="filter.sys"
                placeholder="全部"
                size="small"
                class="input"
                style="margin: 0 10px"
              >
                <el-option label="全部" :value="0"></el-option>
                <el-option
                  v-for="item in system"
                  :key="item.value"
                  :label="item.labelName"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="filter-item">
              <div class="label">用户ID：</div>
              <el-input
                class="input"
                v-model="filter.uid"
                placeholder="请输入内容"
                size="small"
              ></el-input>
            </div>
            <div class="filter-item">
              <div class="label">手机号：</div>
              <el-input
                class="input"
                v-model="filter.phone"
                placeholder="请输入内容"
                size="small"
              ></el-input>
            </div>
            <!-- <div class="filter-item">
                <div class="label">开通时间：</div>
                <el-date-picker
                  v-model="date"
                  type="datetimerange"
                  align="right"
                  unlink-panels
                  class="date-input"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']"
                  size="small"
                >
                </el-date-picker>
              </div> -->
            <div class="btn-box">
              <button class="search" @click="search">筛选</button>
              <button class="reset" @click="reset">重置</button>
            </div>
          </div>
          <div>
            <!-- <button
              class="authorization-btn"
              style="margin-right: 16px"
              @click="toRecord"
            >
              开通记录
            </button> -->
            <button class="authorization-btn" @click="authorizationModal">
              开通身份
            </button>
          </div>
        </div>
        <el-table
          :data="userList"
          class="order-table table no-border-table"
          ref="orderTable"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column prop="sys" align="center" label="系统">
            <div slot-scope="scope">
              {{ systemMap[scope.row.sys] }}
            </div>
          </el-table-column>
          <el-table-column
            prop="uid"
            align="center"
            label="用户ID"
          ></el-table-column>
          <el-table-column
            prop="nickname"
            align="center"
            label="用户昵称"
          ></el-table-column>
          <el-table-column
            prop="phone"
            align="center"
            label="手机号"
          ></el-table-column>
          <el-table-column prop="role" align="center" label="用户身份">
            <div slot-scope="scope">
              {{ roleMap[scope.row.roleTypeOne] }}
            </div>
          </el-table-column>
          <el-table-column
            prop="areaName"
            align="center"
            label="代理区域"
          ></el-table-column>
          <el-table-column prop="created" align="center" label="开通日期">
            <div slot-scope="scope">
              {{ scope.row.openTime | dateFormat }}
            </div>
          </el-table-column>
          <el-table-column prop="created" align="center" label="到期日期">
            <div slot-scope="scope">
              {{ scope.row.overTime | dateFormat }}
            </div>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <div slot-scope="scope">
              <button
                size="mini"
                class="table-btn"
                @click="handleClose(scope.row.uid)"
              >
                关闭
              </button>
              <button
                size="mini"
                class="table-btn"
                @click="handleUpdateDateModal(scope.row)"
              >
                修改到期时间
              </button>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页按钮 -->
      <div class="footer">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          background
          layout="total, prev, pager, next, jumper"
          :page-size="size"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :visible.sync="authorizationShow"
      class="dialog"
      width="618px"
      top="25vh"
    >
      <div slot="title" class="dialog-title">授权身份</div>
      <el-form
        ref="form"
        :rules="rules"
        :model="authorizationForm"
        class="authorization-form"
        label-width="auto"
      >
        <el-form-item label="用户ID：" prop="uid" class="form-item">
          <input
            placeholder="输入用户ID"
            class="input"
            v-model.number="authorizationForm.uid"
            type="number"
            placeholder-class="placeholder"
            onKeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode)))"
            oninput="value = /^\d+(\.{1}\d{0,2})?/g.exec(value) ? /^\d+(\.{1}\d{0,2})?/g.exec(value)[0] : ''"
          />
          <!-- <div class="search-btn" @click="searchUser">查询</div>
            <div v-if="userDetail.role >= 0">
              当前身份：{{ roleMap[userDetail.role] }}
            </div> -->
        </el-form-item>
        <el-form-item label="开通身份：" prop="teamRole" class="form-item">
          <el-select
            v-model.number="authorizationForm.newRole"
            class="select"
            placeholder="请选择"
            style="width: 200px"
            @change="levelChange"
          >
            <el-option
              v-for="item in agent"
              :key="item.value"
              :label="item.labelName"
              :value="+item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="选择省："
          prop="province"
          class="form-item"
          v-if="authorizationForm.newRole"
        >
          <el-select
            v-model="province"
            class="select"
            placeholder="请选择"
            style="width: 200px"
            @change="provinceChange"
          >
            <el-option
              v-for="item in areaArr"
              :key="item.value"
              :label="item.label"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="选择市："
          prop="city"
          class="form-item"
          v-if="authorizationForm.newRole && authorizationForm.newRole < 13"
        >
          <el-select
            v-model="city"
            class="select"
            placeholder="请选择"
            style="width: 200px"
            @change="cityChange"
          >
            <el-option
              v-for="item in cityList"
              :key="item.value"
              :label="item.label"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="选择区："
          prop="county"
          class="form-item"
          v-if="authorizationForm.newRole && authorizationForm.newRole < 12"
        >
          <el-select
            v-model="authorizationForm.county"
            class="select"
            placeholder="请选择"
            style="width: 200px"
          >
            <el-option
              v-for="item in countyList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="到期时间："
          prop="overTime"
          class="form-item"
          v-if="authorizationForm.newRole"
        >
          <el-date-picker
            v-model="authorizationForm.overTime"
            type="datetime"
            class="select"
            style="width: 200px"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="authorizationShow = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="handleAuthorization"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog :visible.sync="visible" class="dialog" width="618px" top="25vh">
      <div slot="title" class="dialog-title">修改到期时间</div>
      <el-form ref="form" class="authorization-form" label-width="auto">
        <el-form-item label="到期时间：" prop="overTime" class="form-item">
          <el-date-picker
            v-model="overTime"
            type="datetime"
            class="select"
            style="width: 200px"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="visible = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="handleUpdateDate"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import dayjs from 'dayjs';
import Header from '../../components/common/header';
import { AREA_OSS } from '@/config'; // oss 图片地址
export default {
  components: {
    Header
  },
  name: 'authorization',
  data() {
    return {
      currentPage: 1, // 当前页码
      size: 20, // 每页条数
      total: 0, // 总页数
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: '用户管理',
        secondTitle: '区域代理管理'
      },
      filter: {
        // 过滤条件
        uid: null,
        phone: '',
        sys: null
      },
      userList: [], // 用户列表
      date: [],
      authorizationShow: false,
      rules: {
        uid: [{ required: true, message: '请输入用户ID', trigger: 'blur' }],
        level: [{ required: true, message: '请选择身份', trigger: 'change' }]
      },
      authorizationForm: {
        uid: null,
        newRole: null,
        province: null,
        county: null,
        city: null,
        overTime: ''
      },
      city: {},
      system: [],
      systemMap: {},
      agent: [],
      agentMap: {},
      areaArr: [],
      provinceList: [],
      cityList: [],
      countyList: [],
      province: {},
      city: {},
      visible: false,
      overTime: '',
      roleMap: {},
      role: []
    };
  },
  filters: {
    // 时间格式化
    dateFormat(date) {
      if (!date) return '-';
      let day = dayjs(date);
      return day.format('YYYY-MM-DD HH:mm:ss');
    }
  },
  mounted() {
    // 获取列表
    this.getUserList();
    this.getDictionary();
    this.getArea();
  },
  computed: {},
  methods: {
    // 切换页码
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getUserList();
    },
    // 获取用户列表
    getUserList() {
      this.filter.start = this.date[0] || '';
      this.filter.end = this.date[1] || '';
      console.log(this.filter);
      this.loading++;
      this.httpGet(this.$root.getAreaAgentList, {
        page: this.currentPage,
        size: this.size,
        ...this.filter
      }).then(
        (res) => {
          this.loading--;
          this.userList = res.list;
          this.total = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getDictionary(){
      this.getDictionaryByName('system');
      this.getDictionaryByName('agent');
      this.getDictionaryByName('role');
    },
    getDictionaryByName(dataName){
      this.loading++;
      this.httpGet(this.$root.getDictionaryByName, {
        dataName
      }).then(
        (res) => {
          this.loading--;
          this[dataName] = res.list;
          let obj = {};
          res.list.forEach(item => {
            obj[item.value] = item.labelName;
          });
          this[dataName + 'Map'] = obj;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 过滤
    search() {
      console.log(this.filter);
      this.currentPage = 1;
      this.getUserList();
    },
    // 重置
    reset() {
      this.filter = {
        // 过滤条件
        uid: null,
        phone: '',
        sys: null
      };
      this.date = [];
      this.getUserList();
    },
    authorizationModal() {
      this.userDetail = {};
      this.authorizationForm = {
        uid: null,
        newRole: null,
        province: null,
        county: null,
        city: null,
        overTime: ''
      };
      this.$refs.form && this.$refs.form.clearValidate();
      this.authorizationShow = true;
    },
    // 身份授权
    handleAuthorization() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading++;
          this.httpPut(this.$root.openAgent, this.authorizationForm).then(
            (res) => {
              this.loading--;
              this.authorizationShow = false;
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.getUserList();
            },
            (res) => {
              this.loading--;
              this.$message.error(res);
            }
          );
        }
      });
    },
    handleClose(uid) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要关闭该用户身份吗？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpPut(this.$root.closeRole, {
          uid,
          changeType: 10
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getUserList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    handleUpdateDateModal(rowData){
      this.uid = rowData.uid;
      this.overTime = rowData.overTime;
      this.visible = true;
    },
    handleUpdateDate(){
      this.loading++;
        this.httpPut(this.$root.updateAgentTime, {
          uid: this.uid,
          overTime: this.overTime
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.visible = false;
            this.getUserList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
    },
    getArea() {
      this.loading++;
      this.httpGet(AREA_OSS, {}).then(
        (res) => {
          this.loading--;
          // 根据市 划分区
          let countyObj = {};
          for (let countyId in res.county_list) {
            let cId = (countyId + '').substring(0, 4);
            if (countyObj[cId]) {
              countyObj[cId].push({
                label: res.county_list[countyId],
                value: +countyId
              });
            } else {
              countyObj[cId] = [
                {
                  label: res.county_list[countyId],
                  value: +countyId
                }
              ];
            }
          }
          // 根据省 划分市
          let areaArr = [];
          let cityObj = {};
          // let cityEmptyObj = {};
          for (let cityId in res.city_list) {
            let pId = (cityId + '').substring(0, 2);
            if (cityObj[pId]) {
              cityObj[pId].push({
                label: res.city_list[cityId],
                value: +cityId,
                children: countyObj[(cityId + '').substring(0, 4)]
              });
            } else {
              cityObj[pId] = [
                {
                  label: res.city_list[cityId],
                  value: +cityId,
                  children: countyObj[(cityId + '').substring(0, 4)]
                }
              ];
            }
          }
          for (let provinceId in res.province_list) {
            areaArr.push({
              value: +provinceId,
              label: res.province_list[provinceId],
              children: cityObj[(provinceId + '').substring(0, 2)]
            });
          }
          // console.log(areaArr);
          this.areaArr = areaArr;
        },
        (err) => {
          this.$message.error(err);
          this.loading--;
        }
      );
    },
    levelChange() {
      this.authorizationForm.province = null;
      this.authorizationForm.city = null;
      this.authorizationForm.county = null;
      this.city = {};
      this.province = {};
    },
    provinceChange(val) {
      this.authorizationForm.province = val.value;
      this.cityList = val.children;
      this.city = {};
      this.authorizationForm.city = null;
      this.authorizationForm.county = null;
    },
    cityChange(val) {
      this.authorizationForm.city = val.value;
      this.countyList = val.children;
      this.authorizationForm.county = null;
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.authorization-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 24px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;

      // 按钮
      .btn {
        width: 100px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin: 16px 0;
      }

      // 表格按钮
      .table-btn {
        // width: 65px;
        height: 24px;
        line-height: 24px;
        color: gray3;
        font-size: 12px;
        margin-right: 8px;
        cancel-btn();
        padding: 0 8px;
      }

      .filter-item {
        margin-right: 45px;
      }

      .select {
        width: 136px;
      }

      .input {
        width: 125px;
      }

      .date-input {
        width: 350px;
      }

      .btn-box {
        margin: 0;
        margin-left: -20px;
      }

      .authorization-btn {
        confirm-btn();
        height: 32px;
        padding: 0 15px;
        white-space: nowrap;
      }

      .table {
        margin-top: 24px !important;
      }
    }
  }

  .footer {
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
    flex-x(flex-end);
    background: white;
  }

  .dialog-content {
    flex-y();
  }

  .authorization-form {
    padding: 16px 0 16px 120px;

    .input {
      width: 220px;
      height: 40px;
      line-height: 40px;
      border: 1px solid #DCDFE6;
      border-radius: 4px;
      padding: 0 15px;
      color: gray9;

      &::placeholder {
        /* WebKit browsers */
        color: #ccc;
      }
    }

    .search-btn {
      display: inline-block;
      confirm-btn();
      width: 72px;
      height: 32px;
      line-height: 32px;
      margin: 0 12px;
    }
  }
}
</style>
